import { Component, OnInit } from '@angular/core';
import { CategoryModel } from '../../../../models/category.model';
import { CategoryService } from '../../../../services/category.service';
import { CityModel } from '../../../../models/city.model';
import { StateModel } from '../../../../models/state.model';
import { CityService } from '../../../../services/city.service';
import { StateService } from '../../../../services/state.service';
import { MkmModel } from '../../../../models/mkm.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MkmService } from '../../../../services/mkm.service';
import { finalize } from 'rxjs';
import swal from "sweetalert2";
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    standalone: true,
    imports: [FormsModule, NgIf, NgForOf],
    providers: [CityService, CategoryService, StateService, MkmService],
    selector: 'mkm-form',
    templateUrl: './mkm-form.component.html',
    styleUrls: ['./mkm-form.component.css']
})
export class MkmFormComponent implements OnInit {
    categorys!: CategoryModel[];
    states!: StateModel[];
    citys!: CityModel[];
    mkm!: MkmModel;
    had!: string;
    errors!: string;
    isRequesting!: boolean;
    selectedFile!: File;
    showAddImage: boolean = true;

    constructor(private categoryService: CategoryService, private cityService: CityService,
        private stateService: StateService, private mkmService: MkmService,
        private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        this.categorys = new Array<CategoryModel>();
        this.states = new Array<StateModel>();
        this.citys = new Array<CityModel>();
        this.mkm = new MkmModel();
        console.log(this.mkm, "mkm data")
        this.route.params.subscribe(p => {
            this.mkm.id = +p['id'];

            //console.log(p);

            if (this.mkm.id) {
                this.getMkmData();
            }

            else {
                this.mkm.id = 0;
                this.had = 'New Mukem';
                this.showAddImage = false;
            }

        });


        this.categoryService.getCategorys().subscribe(c => {
            this.categorys = c;
        });

        this.stateService.getStates().subscribe(s => {
            this.states = s;

        });
    }
    getMkmData() {
        this.mkmService.getMkm(this.mkm.id).subscribe(m => {
            this.mkm = m;
            this.had = 'Edit Mukem';

            this.cityService.getCityStateId(this.mkm.city.stateId).subscribe(c => {
                this.citys = c
            });
        });
    }
    onStateChange() {

        this.getCitys(this.mkm.city.stateId);
    }

    getCitys(id: number) {
        this.cityService.getCityStateId(id).subscribe(c => {
            this.citys = c
        });

    }

    handleOnChange(event: any) {
        const file = event.target.files[0];
        this.selectedFile = file;
        console.log(file, "upload image");
    }

    submit() {
        if (this.mkm.id) {
            this.isRequesting = true;
            this.errors = '';
            this.mkmService.update(this.mkm)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe(s => {
                    this.router.navigate(['/admin/mkm/index']);
                },
                    errors => this.errors = errors);
        }

        else {
            this.isRequesting = true;
            this.errors = '';
            this.mkmService.create(this.mkm)
                .pipe(finalize(() => this.isRequesting = false))
                .subscribe(s => {
                    this.router.navigate(['/admin/mkm/index']);
                },
                    errors => this.errors = errors);
        }
    }

    onCategoryChange(event: any) {
        let selectElementText = event.target['options']
        [event.target['options'].selectedIndex].text;
        console.log(selectElementText);
        this.mkm.mkmTitle = selectElementText;
    }

    onPoiClick() {
        var poi = this.mkm.poi;

        window.open('http://www.google.com/maps/search/?api=1&query=' + poi);
    }

    onCohenClick() {
        window.open('http://www.google.com/maps/search/?api=1&query=' + this.mkm.cohanPlace);
    }

    onDelete(id: number) {
        swal.fire({
            title: 'Are you sure you want to delete this image?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                // Call the delete service if confirmed
                this.mkmService.deleteMkmImage(id).subscribe(
                    res => {
                        console.log('Delete image success', res);
                        this.getMkmData();
                    },
                    err => {
                        console.error('Delete image failed', err);
                    }
                );

                // Show success message
                swal.fire(
                    'Deleted!',
                    'The image has been deleted.',
                    'success'
                );
            }
        });
    }

    addImageIntoMkms() {

        if (this.mkm.id && this.selectedFile) {
            this.mkmService.addImageIntoMkms(this.mkm.id, this.selectedFile).subscribe(
                response => {
                    this.getMkmData();
                    this.selectedFile = null;
                    const fileInput = document.getElementById('uploadImage') as HTMLInputElement;
                    if (fileInput) {
                        fileInput.value = '';
                    }
                },
                error => {
                    console.error(error);
                }
            );
        }
    }
}
